import React, {useContext, useEffect, useState} from "react";
import _ from "lodash";
import {Card, Row} from "react-bootstrap";
import { RequestContext } from "../../context/RequestContext";
import { FieldTypes } from "../../constants/FieldTypes";
import '../../styles/card.scss';
import { StyledBlueButton } from "../../styles/BootstrapStyles";
import JobUtils from "../../utils/JobsUtils";
import RequestUtils from "../../utils/RequestUtils";
import SummaryUtils from "../../utils/SummaryUtils";
const Source = ({ source }) => {
    const {
        _setShowSourceForm,
        _setSelectedSource,
        addNewSource,
        deleteSource,
        status,
        sourceLocation,
        itemList        
    } = useContext(RequestContext);
    const [copyDisabled, setCopyDisabled] = useState(false);
    const [validationStatus, setValidationStatus] = useState({});
    const [metadataFields, setMetadataFields] = useState([]);
    let readOnlyMetaData=_.get(source, "readOnlyMetadata");


    const appendingAdditionalMetadata = () => {
        const sourceLocationMetadata = _.get(sourceLocation, "metadata", []);
        const metadataArray = [...sourceLocationMetadata];
        const additionalMetadata = _.get(sourceLocation, "additionalMetadata");
        if (additionalMetadata) {
            const additionalMetadataPos = _.get(sourceLocation, "additionalMetadataPosition", additionalMetadata.length);
            metadataArray.splice(additionalMetadataPos, 0, ...additionalMetadata);
            return metadataArray
        } else {
            return sourceLocationMetadata
        }
    }
    
    useEffect(() => {
        let readOnlyMetadata = _.get(source, "readOnlyMetadata")
        if (_.isNil(readOnlyMetadata)) {
            if(!_.isNil(validationStatus)){
                setValidationStatus({});
            }
            return;
        }
        let readOnlyMetadataStatus = _.get(readOnlyMetadata, "status");
        if (_.isNil(readOnlyMetadataStatus) || validationStatus === readOnlyMetadataStatus) {
            return;
        }
        setValidationStatus(readOnlyMetadataStatus);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [readOnlyMetaData]);

    useEffect(() => {
        let sourceLocationMetaDataFields = RequestUtils.getMetaDataField(
            appendingAdditionalMetadata(),
            sourceLocation,
            itemList);
        setMetadataFields(sourceLocationMetaDataFields);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleEdit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        _setSelectedSource(source);
        _setShowSourceForm(true);
    };

    const handleCopy = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setCopyDisabled(true)
        addNewSource(_.omit(source, ["key", "readOnlyMetadata"]), () => {setCopyDisabled(false)});
    };

    const handleDelete = (e) => {
        e.preventDefault();
        e.stopPropagation();
        deleteSource(source);
    };

    const getFieldValue = (metadataField, value) => {
        let fieldType = _.get(metadataField, "type");
        if (fieldType === FieldTypes.BOOLEAN) {
            return value === true ? "Yes" : "No";
        } else if (fieldType === FieldTypes.ARRAY) {
            return "" + value.length;
        }
        return value;
    }

    const renderReadOnlyMetadata = () => {
        const overrideMetadataValue = _.get(sourceLocation, "override");
        const fields = _.map(
            SummaryUtils.getHeaders({
              readOnlyMetadata: _.get(sourceLocation, "readOnlyMetadata"),
              overrideReadOnlyMetadata: _.get(overrideMetadataValue, "readOnlyMetadata")
            }, source),
            (column, index) => {
              const valueData = SummaryUtils.getValue(
                column.fields,
                JobUtils.updateSourceField(source)
              );
              return SummaryUtils.hasEmptyFields(
                column.fields,
                JobUtils.updateSourceField(source)
              ) ? null : (
                      <Row className="cardRow">
                          <label className="cardLabel">{column.label + ":"}</label>
                          <span className="cardText">{valueData}</span>
                      </Row>
              );
            }
          );
        if (_.has(source, 'readOnlyMetadata')) {
            if (!_.isNil(validationStatus) && validationStatus === "Valid") {
                return fields;
            }
        } else {
            return null;
        }
    }

    return (
        <Card className="cardContainer">
            {!_.isNil(validationStatus) ? (
                <Row className="validationRow">
                    <label className={
                        validationStatus === "Validating" ? "validationLabelYellow"
                        : validationStatus === "Valid" ? "validationLabelGreen"
                        : validationStatus === "Invalid" ? "validationLabelRed"
                        : validationStatus === "pending_release" ? "validationLabelBlue"
                        : null}>
                            {validationStatus === "Validating" ? "Validating..."
                            : validationStatus === "Valid" ? "Valid"
                            : validationStatus === "Invalid" ? "Invalid"
                            : validationStatus === "pending_release" ? "Pending Release"
                            : null}
                    </label>
                </Row>
            ) : null}
            <Card.Body className="cardBody">
                {_.map(metadataFields, (field) => {
                    let fieldRef = _.get(field, "ref");
                    let value = _.get(source, fieldRef);
                    return value ? (
                        <Row className="cardRow"key={"source-row" + fieldRef}>
                            <label className="cardLabel">{ _.get(field, "label") + ":" }</label>
                            <span className="cardText">{getFieldValue(field, value)}</span>
                        </Row>
                    ) : null;
                })}
                {renderReadOnlyMetadata()}
            </Card.Body>
            <Card.Footer className="cardFooter">
                <Row className="cardButtonRow">
                    <StyledBlueButton
                        className="cardButton"
                        id={"edit"}
                        onClick={handleEdit}>
                        Edit
                    </StyledBlueButton>
                    <StyledBlueButton
                        className="cardButton"
                        id={"copy"}
                        onClick={handleCopy}
                        disabled={copyDisabled || !JobUtils.isDrafting(status)}>
                        Copy
                    </StyledBlueButton>
                    <StyledBlueButton
                        className="cardButton"
                        id={"delete"}
                        onClick={handleDelete}
                        disabled={!JobUtils.isDrafting(status)}>
                        Delete
                    </StyledBlueButton>
                </Row>
            </Card.Footer>
        </Card>
    );
}

export default React.memo(Source);